module.exports = __webpack_public_path__ + "media/images/shared/icon-arrow-497d707ba659c0ed05e68960f9510513.png";